(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  // Rotate announcements when more than one block is present.
  document.querySelectorAll('.ddc-announce[data-autorotate]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.ddc-announce__msg');
    if (msgs.length < 2) return;
    var seconds = parseFloat(bar.getAttribute('data-autorotate')) || 5;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, seconds * 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drama-meter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ddc-meter').forEach(function (root) {
    var panel    = root.querySelector('.ddc-meter__panel');
    var display  = root.querySelector('[data-count-display]');
    var echo     = root.querySelector('[data-count-echo]');
    var hoursEl  = root.querySelector('[data-hours-display]');
    var noteEl   = root.querySelector('[data-saving-note]');
    if (!panel || !display || !hoursEl) return;

    var per      = parseFloat(panel.dataset.perBottle) || 9;
    var baseline = parseInt(panel.dataset.baseline, 10) || 1;
    var MIN = 1, MAX = 99;

    function digits(n, places) {
      var s = String(n);
      while (s.length < places) s = '0' + s;
      return s.slice(-places).split('');
    }

    function paint(count) {
      digits(count, 2).forEach(function (d, i) {
        var box = display.children[i];
        if (box) box.textContent = d;
      });

      var hours = Math.round(count * per);
      digits(hours, 3).forEach(function (d, i) {
        var box = hoursEl.children[i];
        if (box) box.textContent = d;
      });

      if (echo) echo.textContent = count;

      if (noteEl) {
        var saved = Math.max(0, Math.round((count - baseline) * per));
        noteEl.textContent = (noteEl.dataset.template || '')
          .replace('[hours]', saved)
          .replace('[count]', baseline);
      }

      root.querySelectorAll('.ddc-meter__step').forEach(function (b) {
        var next = count + parseInt(b.dataset.step, 10);
        b.disabled = next < MIN || next > MAX;
      });
    }

    var current = parseInt(display.textContent.replace(/\D/g, ''), 10) || MIN;

    root.querySelectorAll('.ddc-meter__step').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = current + parseInt(btn.dataset.step, 10);
        if (next < MIN || next > MAX) return;
        current = next;
        paint(current);
      });
    });

    paint(current);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu toggle. Kept dependency-free so the header works
  // even if any other script on the page fails.
  document.querySelectorAll('.ddc-header__burger').forEach(function (burger) {
    burger.addEventListener('click', function () {
      var nav = document.getElementById('ddc-nav');
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.ddc-ingr__tab');
    if (!tab) return;
    var root = tab.closest('[data-ingr]');
    var cat = tab.getAttribute('data-cat');
    root.querySelectorAll('.ddc-ingr__tab').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    root.querySelectorAll('.ddc-ingr__card').forEach(function (card) {
      card.hidden = Boolean(cat) && card.getAttribute('data-cat') !== cat;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main"] && !Shopify.designMode) return;
  try {
    
  // Offers box: copy a code, and drop any offer whose end time passed after
  // the page was cached (the whole box goes if none are left).
  (function () {
    var box = document.querySelector('[data-offers]');
    if (!box) return;
    var now = Date.now() / 1000;
    box.querySelectorAll('[data-offer-ends]').forEach(function (li) {
      var ends = parseInt(li.getAttribute('data-offer-ends'), 10) || 0;
      if (ends && ends < now) li.remove();
    });
    if (!box.querySelector('[data-offer-ends]')) { box.hidden = true; return; }

    box.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-copy-code]');
      if (!btn) return;
      var code = btn.getAttribute('data-copy-code');
      var done = function () {
        btn.textContent = 'Copied ✓';
        btn.classList.add('is-copied');
        setTimeout(function () { btn.textContent = 'Copy code'; btn.classList.remove('is-copied'); }, 2000);
      };
      var fallback = function () {
        var ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        ta.remove(); done();
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(done, fallback);
      } else {
        fallback();
      }
    });
  })();

  (function () {
    var form = document.getElementById('pdp-form');
    if (!form) return;

    var idField = document.getElementById('pdp-variant-id');
    var box = document.getElementById('pdp-price');
    var cart = document.getElementById('pdp-cart');
    var sticky = document.getElementById('pdp-sticky');
    var hero = document.getElementById('pdp-hero');
    var q = function (root, sel) { return root ? root.querySelector(sel) : null; };
    var setText = function (el, text) { if (el) el.textContent = text; };
    var show = function (el, on) { if (el) el.hidden = !on; };

    function applySize(input) {
      var d = input.dataset;
      var sold = d.available !== 'true';
      var discounted = Boolean(d.mrp);
      idField.value = input.value;

      setText(q(box, '[data-now]'), d.now);
      show(q(box, '[data-mrp-label]'), !discounted);
      show(q(box, '[data-was]'), discounted);
      setText(q(box, '[data-was]'), discounted ? 'MRP ' + d.mrp : '');
      show(q(box, '[data-off]'), discounted);
      setText(q(box, '[data-off]'), discounted ? d.off + '% off' : '');
      setText(q(box, '[data-qty]'), d.qty);
      show(q(box, '[data-qty-wrap]'), Boolean(d.qty));
      setText(q(box, '[data-unit]'), d.unit);
      show(q(box, '[data-unit-wrap]'), Boolean(d.unit));

      setText(document.querySelector('[data-facts-mrp]'), discounted ? d.mrp : d.now);
      setText(document.querySelector('[data-facts-qty]'), d.qty);
      setText(document.querySelector('[data-facts-unit]'), d.unit);

      [cart, q(sticky, '[data-sticky-btn]')].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = sold;
        btn.textContent = sold ? cart.dataset.soldOut : cart.dataset.addLabel;
      });
      setText(q(sticky, '[data-sticky-size]'), d.title);
      setText(q(sticky, '[data-sticky-price]'), d.now);

      if (d.image && hero) {
        hero.src = d.image;
        var stickyImg = q(sticky, '[data-sticky-img]');
        if (stickyImg) stickyImg.src = d.image;
      }

      // Keep the address shareable: /products/body-wash?variant=<id>
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState(null, '', url.toString());
      } catch (e) {}
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'pdp-size') applySize(e.target);
    });

    // Back/forward restores the ticked size from the browser's page cache but
    // not the hidden id or price, so Add to cart could add a different size
    // than the one shown (QA, 2026-09-14). Re-sync from the ticked radio.
    function syncFromChecked() {
      var checked = form.querySelector('input[name="pdp-size"]:checked');
      if (checked && checked.value !== idField.value) applySize(checked);
    }
    window.addEventListener('pageshow', syncFromChecked);
    syncFromChecked();

    document.querySelectorAll('.ddc-pdp__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!hero) return;
        hero.src = btn.dataset.full;
        document.querySelectorAll('.ddc-pdp__thumb').forEach(function (b) { b.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
      });
    });

    // Quantity stepper (1–10), keeps the number input valid.
    var qtyInput = form.querySelector('.ddc-qty__input');
    form.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-qty-step]');
      if (!b || !qtyInput) return;
      var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
      qtyInput.value = Math.min(10, Math.max(1, n));
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      var n = parseInt(qtyInput.value, 10);
      qtyInput.value = isNaN(n) ? 1 : Math.min(10, Math.max(1, n));
    });

    // Sticky bar: only once the real button has left the screen upward.
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      }).observe(cart);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ddc-rail').forEach(function (rail) {
    var track = rail.querySelector('[data-rail-track]');
    if (!track) return;
    rail.querySelectorAll('[data-rail]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var first = track.querySelector('.ddc-rail__item');
        var step = first ? first.getBoundingClientRect().width + 16 : 240;
        track.scrollBy({ left: step * parseInt(btn.dataset.rail, 10), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  // Size pills: swap the selected variant and reflect its price.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.ddc-card__size input')) return;

    var form = input.closest('[data-card-form]');
    if (!form) return;

    form.querySelectorAll('.ddc-card__size').forEach(function (label) {
      label.classList.toggle('is-active', label.contains(input));
    });

    var priceEl = form.querySelector('[data-price-target]');
    if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;

    // Stock state follows the selected size, not the product as a whole —
    // 300 ml can be sold out while 100 ml is still available.
    var available = input.dataset.available === 'true';
    var qty = parseInt(input.dataset.qty, 10);
    var stockEl = form.querySelector('[data-stock-target]');
    var btn = form.querySelector('[data-cart-btn]');

    if (stockEl) {
      var low = parseInt(stockEl.dataset.low, 10);
      if (!available) {
        stockEl.textContent = stockEl.dataset.outText;
      } else if (!isNaN(qty) && qty > 0 && qty <= low) {
        stockEl.textContent = (stockEl.dataset.lowText || '').replace('[count]', qty);
      } else {
        stockEl.textContent = '';   // tracked-and-plentiful, or untracked (qty -1)
      }
    }

    if (btn) {
      btn.disabled = !available;
      btn.textContent = available ? btn.dataset.addLabel : btn.dataset.outLabel;
    }
  });

  // Tag filter pills.
  document.querySelectorAll('.ddc-grid-sec__filters').forEach(function (bar) {
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;

      bar.querySelectorAll('[data-filter]').forEach(function (b) {
        b.setAttribute('aria-selected', String(b === btn));
      });

      var want = btn.dataset.filter;
      var section = bar.closest('.ddc-grid-sec');
      section.querySelectorAll('.ddc-card').forEach(function (card) {
        var tags = (card.dataset.tags || '').split(/\s+/);
        card.hidden = !(want === '*' || tags.indexOf(want) !== -1);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
